<template>
  <div>
    <div>
      <!-- Row Loop -->
      <b-row
        v-for="document in $store.getters[`documents/${resourceType}Documents`]"
        :id="document.documentId"
        :key="document.documentId"
      >
        <b-col>
          <document-card
            :document="document"
            @apply-document-to-change="documentToChange = $event"
            @updated-document-status = "refetchDocuments"
          />
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-if="documentToChange"
      id="update-document-modal"
      ok-only
      ok-title="Close"
      centered
      size="xl"
      :title="`Update ${documentToChange.name} Document`"
      @hidden="resetModal"
    >
      <b-overlay
        :show="uploadingFile"
        rounded="sm"
        no-fade
      >
        <b-row>
          <b-col md="10">
            <validation-observer ref="documentListRef">
              <b-form>
                <validation-provider
                  #default="validationContext"
                  name="Document"
                  rules="image"
                >
                  <b-form-group
                    label="Document"
                    label-for="document"
                  >
                    <b-form-file
                      id="document"
                      v-model="file"
                      :state="validationContext.valid"
                      accept="image/*"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      @change="fileChange( $event )"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col md="2">
            <b-button
              v-ripple.400="'rgba(255, 255,  255, 0.15)'"
              variant="primary"
              class="mt-0 mt-md-2"
              :disabled="!file"
              @click="uploadDocument"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-25"
              />
              <span>Update</span>
            </b-button>
          </b-col>
        </b-row>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BCol, BRow, BButton, VBModal, BModal, BForm, BFormFile, BOverlay, BFormInvalidFeedback, BFormGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { image } from '../../../utils/validations'
import useDocumentsList from '@/views/driver/documents/useDocumentsList'
import DocumentCard from './DocumentCard.vue'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BFormGroup,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    DocumentCard,
    BCol,
    BRow,
    BButton,
    BModal,
    BForm,
    BFormFile,
    BOverlay,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    resourceType: {
      type: String,
      required: true,
    },
    resourceId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const file = ref(null)
    const uploadingFile = ref(false)
    const componentKey = ref(1)

    const {
      documentToChange,
      fetchDocuments,
    } = useDocumentsList()

    return {
      documentToChange,
      file,
      uploadingFile,
      fetchDocuments,
      componentKey,
      image,
    }
  },
  methods: {
    fileChange(event) {
      if (event.target.file && event.target.files.length) {
        this.file = event.target.files
      }
    },
    resetModal() {
      this.file = null
    },
    async uploadDocument() {
      const isValid = await this.$refs.documentListRef.validate()
      if (!isValid) {
        return
      }
      try {
        this.uploadingFile = true
        const { file } = this
        const fileExtension = file.name.split('.').pop()
        const result = await this.$store.dispatch('documents/getPresignedUrl', {
          name: file.name,
          [`${this.resourceType}Id`]: this.resourceId,
          documentType: this.documentToChange.id,
          extension: `.${fileExtension}`,
        })
        this.file = null
        console.log(result, 'doccccccc')
        await this.$store.dispatch('documents/s3Upload', { url: result.url, file })
        await this.$store.dispatch('documents/handleDocumentStatus', {
          driverId: this.resourceId,
          documentId: result.id,
          status: 'PENDING',
        })
        this.fetchDocuments(this.resourceType, this.resourceId).then(() => {
          this.uploadingFile = false
        })
      } catch (err) {
        errorNotification('An error occured..')
      } finally {
        this.uploadingFile = false
      }
    },
    async refetchDocuments() {
      await this.fetchDocuments(this.resourceType, this.resourceId)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
